import { render, staticRenderFns } from "./location_categories.vue?vue&type=template&id=661c79f6&scoped=true&"
import script from "./location_categories.vue?vue&type=script&lang=js&"
export * from "./location_categories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661c79f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('661c79f6')) {
      api.createRecord('661c79f6', component.options)
    } else {
      api.reload('661c79f6', component.options)
    }
    module.hot.accept("./location_categories.vue?vue&type=template&id=661c79f6&scoped=true&", function () {
      api.rerender('661c79f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/base/location_modal/tabs/location_categories.vue"
export default component.exports